<template>
    <div class="container-fluid">
        <h1>{{$t('menuItemFeedbackCategories')}}</h1>
        <br />
		<div class="col-xs-12 col-md-10 col-lg-8" style="margin-bottom: 30px;">
			<b-form name="feedbackCategoryForm" v-on:submit.prevent="$_onSubmit" class="pb-5">
				<!-- Table with categories -->
				<b-table striped
						 hover
						 small
                         outlined
                         bordered
						 v-show="dataLoaded"
						 :tbody-tr-class="$_rowClass"
						 :items="feedbackCategoryValues"
						 :fields="fields">
					<!-- Category name -->
					<template v-slot:cell(name)="row">
						<!-- Category name value -->
						<span v-if="row.item.edit === false"> {{row.item.name}} </span>
						<!-- Category name input -->
						<span v-else>
							<x-input :text="''"
									 v-model="row.item.name"
									 :name="'item-category-name'"
									 :placeholder="placeholders.name"
									 :maxlength="150"
									 :required="false"
									 @input="$_onInputName"
									 :invalidMessage="nameMessage"
									 :state="validStateName">
							</x-input>
						</span>
					</template>
					<!-- Category email -->
					<template v-slot:cell(adminEmail)="row">
						<!-- Category admin email value -->
						<span v-if="row.item.edit === false"> {{row.item.adminEmail}} </span>
						<!-- Category admin email input -->
						<span v-else>
							<EmailInput :text="''"
										v-model="row.item.adminEmail"
										:name="'item-admin-email'"
										:placeholder="placeholders.email"
										:maxlength="4000"
										:required="false"
										:pattern="emailRegex"
										v-bind:validState.sync="validStateEmail">
							</EmailInput>
						</span>
					</template>
					<!-- Edit button -->
					<template v-slot:cell(edit)="row">
						<a href="#" @click="$_onEditFeedbackCategory(row.item)">
							<!-- Start edit -->
							<em v-if="row.item.edit === false" class="fas fa-edit"></em>
							<!-- Stop edit -->
							<em v-else class="fas fa-check" v-bind:class="[validStates ? 'valid': 'invalid' ]"></em>
						</a>
					</template>
						<!-- Remove button -->
						<template v-slot:cell(remove)="row">
							<b-nav size="sm" @click="$_onDeleteFeedbackCategory(row.item.id)" class="delete">
								<em class="fas fa-times"></em>
							</b-nav>
						</template>
				</b-table>
				<div class="form-group">
					<div>
						<!-- Input for new values -->
						<div class="row">
							<div class="col-md-5">
								<!-- Category Name -->
								<x-input :text="labelCategoryName"
										 v-model="newCategory.name"
										 :id="'new-category-name'"
                                         :name="'new-category-name'"
										 :placeholder="placeholders.name"
										 :maxlength="150"
										 :required="false"
										 @input="$_onInputName"
										 :invalidMessage="nameMessage"
										 :state="validStateName">
								</x-input>
							</div>
							<div class="col-md-5">
								<!-- Category admin email -->
								<EmailInput :text="$t('labelCategoryAdminEmail')"
											v-model="newCategory.adminEmail"
											:name="'new-category-admin-email'"
											:placeholder="placeholders.email"
											:maxlength="4000"
											:required="false"
											:pattern="emailRegex"
											v-bind:validState.sync="validStateEmail">
								</EmailInput>
							</div>
							<div>
								<!-- Add button -->
								<b-button id="add-category"
										  :disabled="isBtnAddDisabled"
										  variant="primary"
										  @click="$_onAddNewFeedbackCategory">{{$t('btnAddLabel')}}</b-button>
							</div>
						</div>
					</div>
					<label v-show="!validStateEmail" class="errormsg">{{ $t('userIncorrectEmail') }}</label>
				</div>
				<!-- Save and cancel button (no remove button) -->
				<SubmitCancelRemove :is-saving="isSaving"
									:mode="modeAddConst"
									@cancel="$_gotoHome"
									:isBtnSaveDisabled="!validStateEmail">
				</SubmitCancelRemove>
			</b-form>
		</div>
    </div>
</template>

<script>
    import { orderBy } from 'lodash';
    import { nprogress } from '../../services/utilities';
    import { MODE_ADD } from '../../constants';
    import XInput from '../../components/BaseComponents/x-input.vue';
    import modalMixin from '../../components/Mixins/ModalMixin.vue';
    import SubmitCancelRemove from '../../components/SubmitCancelRemove.vue';
    import EmailInput from '../../components/EmailInput.vue';

    export default {
        mixins: [
            modalMixin,
        ],

        components: {
            'x-input': XInput,
            EmailInput,
            SubmitCancelRemove
        },

        data() {
            return {
                // Constants
                modeAddConst: MODE_ADD,

                feedbackCategories: [],
                dataLoaded: false,
                isSaving: false,
                validStateEmail: true,
                validStateName: true,
                // table fields
                fields: [
                    {
                        key: 'name',
                        label: this.$t('labelCategoryName'),
                        sortable: false,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'adminEmail',
                        label: this.$t('labelCategoryAdminEmail'),
                        sortable: false,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'edit',
                        label: '',
                        sortable: false,
                        thStyle: { border: 0 }
                    },
                    {
                        key: 'remove',
                        label: '',
                        sortable: false,
                        thStyle: { border: 0 }
                    }
                ],

                labelCategoryName: this.$t('labelCategoryName'),
                labelCategoryAdminEmail: this.$t('labelCategoryAdminEmail'),
                nameMessage: this.$t('categoryNameAlreadyExistsMessage'),
                newId: -1,
                newCategory: {
                    name: '',
                    adminEmail: ''
                },
                // placeholders list
                placeholders: {
                    name: '',
                    email: '',
                },
                // Regular expression for email
                emailRegex: /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
            };
        },

        computed: {
            /**
              * Check if category can be added
              * @returns {boolean} indicating if category can be added
              */
            isBtnAddDisabled: function () {
                return this.newCategory.name.length === 0 || this.newCategory.adminEmail.length === 0 || !this.validStateName || !this.validStateEmail;
            },
            feedbackCategoryValues() {
                if (this.feedbackCategories && this.feedbackCategories.length > 0) {
                    // Hide records with deleted flag
                    return this.feedbackCategories.filter(item => item.deleted === false);
                }
                return [];
            },
            validStates() {
                return this.validStateName && this.validStateEmail;
            }
        },

        mounted() {
            this.$_getFeedbackCategories();
        },

        methods: {
            $_feedbackCategoryNameKeyExists() {
                return this.feedbackCategories.some(fc => fc.name === this.newCategory.name);
            },
            $_gotoHome() {
                this.$router.push({ path: '/' });
            },
            async $_getFeedbackCategories() {
                nprogress.start();
                await this.$store.dispatch('useApiData', {
                    name: 'GetFeedbackCategories'
                }).then((result) => {
                    // sort records (lodash)
                    if (result.data && result.data.length > 1) {
                        result.data = orderBy(result.data, [o => o.name.toLowerCase()]);
                    }
                    // set deleted and edit flag to false
                    for (const category of result.data) {
                        category.deleted = false;
                        category.edit = false;
                    }

                    this.feedbackCategories = result.data;
                    this.dataLoaded = true;
                    nprogress.done();
                });
            },
            async $_onSubmit() {
                this.$_onAddNewFeedbackCategory();
                nprogress.start();
                this.isSaving = true;
                await this.$store.dispatch('useApiData', {
                    name: 'SaveFeedbackCategory',
                    data: this.feedbackCategories
                }).then((result) => {
                    this.isSaving = false;
                    this.$_getFeedbackCategories();
                    // show result
                    this.showToast({
                        message: this.$t('categoriesCardSavedConfirmation'),
                        variant: 'success',
                        autoHideDelay: 2500,
                    });
                    nprogress.done();
                }, (error) => {
                    nprogress.done();
                    this.isSaving = false;
                    this.showToast({
                        title: this.$t('saveFailureTitle'),
                        message: error.message,
                        variant: 'danger',
                        autoHideDelay: 10000,
                    });
                });
            },
            $_onAddNewFeedbackCategory() {
                if (this.newCategory.name.length > 0 && this.newCategory.adminEmail.length > 0) {
                    // Create a unique id
                    this.newId = this.newId - 1;
                    this.feedbackCategories.push({
                        id: this.newId,
                        name: this.newCategory.name,
                        adminEmail: this.newCategory.adminEmail,
                        deleted: false,
                        edit: false
                    });
                    // Reset values
                    this.newCategory.name = '';
                    this.newCategory.adminEmail = '';
                }
            },
            $_onDeleteFeedbackCategory(value) {
                const categoryToDelete = this.feedbackCategories.find(c => c.id === value);
                // Deleted flag is used to remove records in back-end
                categoryToDelete.deleted = true;
            },
            $_onEditFeedbackCategory(item) {
                if (!this.validStates && item.edit) {
                    return;
                }
                item.edit = !item.edit;
            },
            $_onInputName() {
                this.validStateName = !this.$_feedbackCategoryNameKeyExists();
            },
            $_rowClass() {
                return 'tablerow';
            },
        }
    };
</script>

<style scoped>
    .delete {
        color: red;
        padding: 0.2em;
    }
	.valid {
		color: #28a745;
	}
	.invalid {
		cursor: not-allowed;
		color: grey;
	}

    #add-category {
        margin-top: 24px;
        height: 38px;
    }
</style>
